const validationLogin = (message) => {
    let messageSpanish = "";

    if(message === "The password is invalid or the user does not have a password."){
        messageSpanish = "La contraseña es incorrecta"
    }
    else if(message === "There is no user record corresponding to this identifier. The user may have been deleted."){
        messageSpanish = "Correo no registrado"
    }
    else if(message === "Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later."){
        messageSpanish = "Has probado muchas veces, espere unos minutos"
    }


    return messageSpanish;
}

export default validationLogin;